import { fetcher } from "helpers/fetcher";

import { TUpdateClientBasicInfoReq, TUpdateClientBasicInfoRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateClientBasicInfo = async (
  payload: TUpdateClientBasicInfoReq
) => {
  return await fetcher<
    TUpdateClientBasicInfoRes,
    TUpdateClientBasicInfoReq["data"]
  >(ENDPOINT.USER.UPDATE_CLIENT_BASIC_INFO, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_CLIENT_BASIC_INFO.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationUpdateClientBasicInfo = async (
  payload: TUpdateClientBasicInfoReq
) => {
  return (await updateClientBasicInfo(payload)).data;
};

mutationUpdateClientBasicInfo._key = (payload: TUpdateClientBasicInfoReq) => [
  ENDPOINT.USER.UPDATE_CLIENT_BASIC_INFO.url,
  payload,
];
